<template>
    <div>
        <page-title>编辑插件分类信息</page-title>
        <page-body>
            <el-form v-loading="loading" :model="form" :rules="rules" ref="form">
                <el-form-item label="名称" prop="display_name">
                    <el-input v-model="form.display_name" placeholder="分类名称"/>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="form.sort" placeholder="排序（升序，1～10000）"/>
                </el-form-item>
                <el-form-item label="色调" prop="color">
                    <el-color-picker v-model="form.color"></el-color-picker>
                </el-form-item>
                <el-form-item>
                    <el-button :loading="btnLoading" @click="submit('form')" type="primary">{{form.id ? '保存' : '添加'}}
                    </el-button>
                </el-form-item>
            </el-form>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'

export default {
    components: {},
    data() {
        return {
            loading: false,
            btnLoading: false,
            detail: null,
            rules: {
                display_name: [
                    {required: true, message: '请填分类名称。'}
                ],
                sort: [
                    {required: true, message: '请填写排序（1～10000）。'}
                ],
                color: [
                    {required: true, message: '请选择颜色。'}
                ]
            },
            form: {
                id: null,
                display_name: '',
                sort: 100,
                color: ''
            },
            editorOption: {}
        }
    },
    created() {
        if (this.$route.query.id) {
            this.form.id = this.$route.query.id
            this.loadData()
        }
    },
    methods: {
        loadData() {
            this.loading = true
            axios({
                url: 'admin/plugin/cat-detail',
                params: {
                    id: this.form.id
                }
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.form = e.data.data
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        submit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.btnLoading = true
                    axios({
                        url: this.form.id ? 'admin/plugin/cat-update' : 'admin/plugin/cat-create',
                        method: 'post',
                        data: this.form
                    }).then(e => {
                        this.btnLoading = false
                        if (e.data.code === 0) {
                            this.$message.success('保存成功。')
                            this.$router.push('/dashboard/admin/plugin/cat-index')
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    })
                }
            })
        }
    }
}
</script>
